import React from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from '@material-ui/core/CircularProgress';
import {API_LOGIN } from '../ApiUrl';
import Axios from '../actions/Axios'
import {
  hideMessage,
  showAuthLoader,
  userSignInSuccess,
  hideAuthLoader
} from 'actions/Auth';

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      errorMessage:''
    }
  }

    componentDidUpdate() {
        if (this.props.showMessage) {
        setTimeout(() => {
            this.props.hideMessage();
        }, 100);
        }
        if (this.props.authUser !== null) {
            this.props.history.push('/');
        }
    }

    loginUser = () => {
        this.props.showAuthLoader();
        const { email, password } = this.state;

        const formData = {
            email: email.trim(),
            password: password.trim()
        }

        Axios.post(API_LOGIN, formData).then((response) => {
            const data = response.data;

            if(data.status === 0){
                this.setState({errorMessage:data.message})
            }else{
                localStorage.setItem('token', data.token);
                localStorage.setItem('_id', data.data[0]._id);
                localStorage.setItem('name', data.data[0].name);
                localStorage.setItem('role', data.data[0].role);
                localStorage.setItem('user_id', data.token);

                this.props.userSignInSuccess(data.token)
                setTimeout(() => {
                    this.props.history.push('/app/dashboard/index');
                }, 600);

            }
            this.props.hideAuthLoader();
        }).catch((err) => {
            let error =err.response.data.message;
            this.setState({errorMessage:"server error, Please try after some time."})
            this.props.hideAuthLoader();
        })
    }

  render() {
    const {
      email,
      password,
      errorMessage
    } = this.state;
    console.log(this.state)
    const {showMessage, loader, alertMessage} = this.props;
    return (
        <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
            <div className="app-login-main-content">

                <div className="app-logo-content d-flex align-items-center justify-content-center">
                    <Link className="logo-lg" to="/" title="Jambo">
                    <img src={require("assets/images/logo.png")} alt="jambo" title="jambo" className="logo"/>
                    </Link>
                </div>

                <div className="app-login-content">
                    <div className="app-login-header mb-4">
                        <h1>Sign In</h1>
                    </div>

                    <div className="app-login-form">
                        <form>
                            <fieldset>
                                <TextField
                                    label="Enter Email"
                                    fullWidth
                                    onChange={(event) => this.setState({email: event.target.value})}
                                    defaultValue={email}
                                    margin="normal"
                                    className="mt-1 my-sm-3"
                                />
                                <TextField
                                    type="password"
                                    label="Password"
                                    fullWidth
                                    onChange={(event) => this.setState({password: event.target.value})}
                                    defaultValue={password}
                                    margin="normal"
                                    className="mt-1 my-sm-3"
                                />

                                <div className="mb-3 d-flex align-items-center justify-content-between">
                                    <Button onClick={() => this.loginUser()}
                                        variant="contained" color="primary">
                                        <IntlMessages id="appModule.signIn"/>
                                    </Button> <p className='error'>{errorMessage}</p>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>

            </div>
            {
            loader &&
            <div className="loader-view">
                <CircularProgress/>
            </div>
            }
            {showMessage && NotificationManager.error(alertMessage)}
            <NotificationContainer/>
        </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  const {loader, alertMessage, showMessage, authUser} = auth;
  return {loader, alertMessage, showMessage, authUser}
};

export default connect(mapStateToProps, {
 hideMessage,
  showAuthLoader,
  userSignInSuccess,
  hideAuthLoader
})(SignIn);
